import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { ParticlesBounceFactor } from "./ParticlesBounceFactor";
export var ParticlesBounce = /*#__PURE__*/function () {
  function ParticlesBounce() {
    _classCallCheck(this, ParticlesBounce);

    this.horizontal = new ParticlesBounceFactor();
    this.vertical = new ParticlesBounceFactor();
  }

  _createClass(ParticlesBounce, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }

      this.horizontal.load(data.horizontal);
      this.vertical.load(data.vertical);
    }
  }]);

  return ParticlesBounce;
}();